import { render, staticRenderFns } from "./resume-permits-view.vue?vue&type=template&id=87498f24&"
import script from "./resume-permits-view.vue?vue&type=script&lang=js&"
export * from "./resume-permits-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports